import React, { useState, useEffect, useContext } from "react"
import { useHistory } from "react-router-dom"

import RegistradorContext from "../../../../contexts/registradorContext"
import ServicosContext from "../../../../contexts/servicosContext"
import { useSnackbar } from "notistack"

import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles"
import MotorcycleIcon from "@material-ui/icons/Motorcycle"
import CheckIcon from "@material-ui/icons/Check"
import Backdrop from "@material-ui/core/Backdrop"
import Radio from "@material-ui/core/Radio"
import AlertFixo from "@material-ui/lab/Alert"
import PhoneIcon from "@material-ui/icons/Phone"
import EditIcon from "@material-ui/icons/Edit"
import RadioGroup from "@material-ui/core/RadioGroup"
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber"
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle"
import CheckCircleIcon from "@material-ui/icons/CheckCircle"
import AirlineSeatReclineNormalIcon from "@material-ui/icons/AirlineSeatReclineNormal"
import NativeSelect from "@material-ui/core/NativeSelect"
import PrintIcon from "@material-ui/icons/Print"
import TransferWithinAStationIcon from "@material-ui/icons/TransferWithinAStation"
import PaymentIcon from "@material-ui/icons/Payment"
import LocationOnIcon from "@material-ui/icons/LocationOn"
import CardActions from "@material-ui/core/CardActions"
import SwapHorizIcon from "@material-ui/icons/SwapHoriz"
import InputAdornment from "@material-ui/core/InputAdornment"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import ButtonGroup from "@material-ui/core/ButtonGroup"
import InputBase from "@material-ui/core/InputBase"
import AddIcon from "@material-ui/icons/Add"
import RemoveIcon from "@material-ui/icons/Remove"
import FormLabel from "@material-ui/core/FormLabel"
import FormGroup from "@material-ui/core/FormGroup"
import Skeleton from "@material-ui/lab/Skeleton"
import FormControl from "@material-ui/core/FormControl"
import Stepper from "@material-ui/core/Stepper"
import Step from "@material-ui/core/Step"
import StepLabel from "@material-ui/core/StepLabel"
import ArrowRightIcon from "@material-ui/icons/ArrowRight"
import CircularProgress from "@material-ui/core/CircularProgress"
import Button from "@material-ui/core/Button"
import ListSubheader from "@material-ui/core/ListSubheader"
import Snackbar from "@material-ui/core/Snackbar"
import MuiAlert from "@material-ui/lab/Alert"
import PropTypes from "prop-types"
import Box from "@material-ui/core/Box"
import PersonPinIcon from "@material-ui/icons/PersonPin"
import CardActionArea from "@material-ui/core/CardActionArea"
import CardContent from "@material-ui/core/CardContent"
import CardMedia from "@material-ui/core/CardMedia"
import { Card, Row, Col } from "react-bootstrap"
import Avatar from "@material-ui/core/Avatar"
import TextField from "@material-ui/core/TextField"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import Divider from "@material-ui/core/Divider"
import ListItemText from "@material-ui/core/ListItemText"
import ListItemAvatar from "@material-ui/core/ListItemAvatar"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import Fab from "@material-ui/core/Fab"
import Slide from "@material-ui/core/Slide"

import { textoHTML, mandarImprimir } from "../../../../services/functionsGerais"

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const useStyles = makeStyles(theme => ({
    fixed: {
        position: "fixed",
        right: "2em",
        bottom: "2em",
        zIndex: 1000,
    },
    fixedMesa: {
        position: "fixed",
        right: "2em",
        bottom: "2em",
        zIndex: 2000,
    },
    fixedMesaFechar: {
        position: "fixed",
        right: "2em",
        bottom: "7em",
        zIndex: 2000,
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    rootAlert: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    backdrop: {
        // zIndex: theme.zIndex.drawer + 999999,
        color: "#fff",
    },
    pos: {
        marginBottom: 12,
    },
    heading: {
        width: "100%",
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    rootList: {
        width: "100%!important",
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: "inline",
        width: "100%",
    },
    appBar: {
        position: "fixed",
    },
    appContainer: {
        paddingTop: "6em",
        backgroundColor: "#f4f4f4",
        // height: "100%",
        // minHeight: "-webkit-fill-available",
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    list: {
        width: 250,
    },
    fullList: {
        width: "auto",
    },
}))

export default function Index() {
    const autorizacao = localStorage.getItem("chaveSistema")
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )
    const classes = useStyles()
    const theme = useTheme()
    const history = useHistory()

    const {
        openCadastroCliente,
        setOpenCadastroCliente,
        visualizarPedido,
        setVisualizarPedido,
        cadastrarUsuario,
    } = useContext(RegistradorContext)

    const { enqueueSnackbar } = useSnackbar()

    const { configuracoes } = useContext(ServicosContext)

    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    return visualizarPedido?.id ? (
        <Dialog
            open={visualizarPedido?.id ? true : false}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => setVisualizarPedido({})}
            // style={{"zIndex": "999999"}}
        >
            <form onSubmit={cadastrarUsuario}>
                <DialogTitle>{`Pedido #${visualizarPedido.id} - Mesa ${visualizarPedido.mesa}`}</DialogTitle>
                <DialogContent>
                    <Row>
                        <Col xs={12} md={12} lg={12} id="textoHTML">
                            {textoHTML(visualizarPedido?.textoImpressao)}
                        </Col>
                    </Row>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setVisualizarPedido({})
                        }}
                    >
                        Fechar
                    </Button>
                    <Button
                        onClick={() => {
                            // setModalInformacoes(false)
                            mandarImprimir(visualizarPedido?.textoImpressao, 1)
                        }}
                        style={{ color: "#28a745" }}
                    >
                        Imprimir
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    ) : (
        <React.Fragment></React.Fragment>
    )
}
